import helpActionTypes from './HelpActionTypes';
import { AsyncRequestStatus, getDefaultAsyncWrapperObj, getCompletedAsyncWrapperObj } from '@ane/core/lib/models';
import { loadExperimentationGroupsEpicReducer } from '../epics/HelpEpics';
export var OperationStatus;
(function (OperationStatus) {
    OperationStatus[OperationStatus["NoOp"] = 0] = "NoOp";
    OperationStatus[OperationStatus["Initiated"] = 1] = "Initiated";
    OperationStatus[OperationStatus["Success"] = 2] = "Success";
    OperationStatus[OperationStatus["Failure"] = 3] = "Failure";
})(OperationStatus || (OperationStatus = {}));
const getDefaultState = {
    categories: undefined,
    ticketCreationError: false,
    deleteFlightStatus: OperationStatus.NoOp,
    flightData: undefined,
    getFlightStatus: OperationStatus.NoOp,
    creatingTicket: false,
    managementGroups: undefined,
    managementGroupUpdated: false,
    experimentationGroups: getDefaultAsyncWrapperObj(),
    mdsFlightControl: undefined,
    createdTicket: undefined,
    uploadUserFile: getDefaultAsyncWrapperObj(),
};
export const HelpReducer = (state = getDefaultState, actionResult) => {
    state = loadExperimentationGroupsEpicReducer.reduxChange(state, actionResult);
    switch (actionResult.type) {
        case helpActionTypes.CREATE_TICKET:
            return Object.assign(Object.assign({}, state), { creatingTicket: true });
        case helpActionTypes.CREATED_TICKET:
            return Object.assign(Object.assign({}, state), { ticketCreationError: 'Error' in actionResult.payload, createdTicket: actionResult.payload, creatingTicket: false });
        case helpActionTypes.UPLOAD_USER_FILE:
            return Object.assign(Object.assign({}, state), { uploadUserFile: {
                    status: AsyncRequestStatus.Pending,
                    data: null,
                    error: null,
                } });
        case helpActionTypes.UPLOADED_USER_FILE:
            return Object.assign(Object.assign({}, state), { uploadUserFile: getCompletedAsyncWrapperObj(actionResult.payload, !actionResult.payload || actionResult.payload.length === 0 ? 'error' : '') });
        case helpActionTypes.LOADED_MGMT_GRPS:
            return Object.assign(Object.assign({}, state), { managementGroups: actionResult.payload });
        case helpActionTypes.LOAD_FLIGHT_DATA:
            return Object.assign(Object.assign({}, state), { getFlightStatus: OperationStatus.Initiated });
        case helpActionTypes.LOADED_FLIGHT_DATA:
            const actionResultCast = actionResult;
            return Object.assign(Object.assign({}, state), { flightData: actionResultCast.payload.data, getFlightStatus: actionResultCast.payload.status === AsyncRequestStatus.Completed ? OperationStatus.Success : OperationStatus.Failure });
        case helpActionTypes.DELETE_FLIGHT:
            return Object.assign(Object.assign({}, state), { deleteFlightStatus: OperationStatus.Initiated });
        case helpActionTypes.DELETED_FLIGHT:
            return Object.assign(Object.assign({}, state), { deleteFlightStatus: actionResult.payload === Object(actionResult.payload) &&
                    ('Error' in actionResult.payload || 'Message' in actionResult.payload)
                    ? OperationStatus.Failure
                    : OperationStatus.Success });
        case helpActionTypes.LOADED_MDS_FLIGHT_CONTROL:
            return Object.assign(Object.assign({}, state), { mdsFlightControl: actionResult.payload });
        case helpActionTypes.CHANGED_MG:
            return Object.assign(Object.assign({}, state), { managementGroupUpdated: true });
        case helpActionTypes.LOADED_CATEGORIES:
            return Object.assign(Object.assign({}, state), { categories: actionResult.payload });
        case helpActionTypes.CLEAR_UPLOADED_FILE_CACHE:
            return Object.assign(Object.assign({}, state), { uploadUserFile: {
                    status: AsyncRequestStatus.NotStarted,
                    data: null,
                    error: null,
                } });
        default:
            return state;
    }
};
export default HelpReducer;

//# sourceMappingURL=HelpReducer.js.map
